// const request = require('./request');
const pagination = require('./pagination');
const utils = require('./common/utils');
/**
 * 推送需求信息到服务器
 * @param {需求类型，1：采购；2：供应} nType
 * @param {需求名称} strName
 * @param {需求内容} strContent
 * @param {发布成功或失败回调} callback
 */
function publishRequirement2Server(nType, strName, strContent, mobile, productionPlace, description, fn) {
  const param = {
    'title': strName
  };
  mobile && (param.contactMobile = mobile);
  strContent && (param.needNum = strContent);
  productionPlace && (param.place = productionPlace);
  description && (param.content = description);

  $.ajax({
    type: 'POST',
    url: (nType === 1 ? '/supply/procurement' : '/supply/supplier'),
    data: param,
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.result) {
        nType === 1 ? onClickedProcurementPageItem(1) : onClickedSupplierPageItem(1);
        fn && fn(true);
      } else {
        const msg = (response && response.data && response.data.msg) || '';
        fn && fn(false, msg);
      }
    }
  });
}

function getElementDomValue(path, value) {
  const doms = $(path);
  if (value !== undefined && value !== null) {
    doms.val(value);
  }
  return doms && doms.val();
}
/*
*   PC端点击发布需求(采购、供应)
*/
function onClickedPublishRequirement() {
  const displayTipView = require('./common').displayElementView;

  var nType;
  $('.release-title a').each(function(index) {
    var classNames = $('.release-title a').eq(index).attr('class');
    if (classNames) {
      if (index === 0) {
        nType = 1;
      } else {
        nType = 2;
      }
    }
  });
  const tipElement = $('.release .tip');
  let name;
  let productionPlace;
  let amount;
  let mobile;
  let content;
  let fnCallback;
  switch (nType) {
    // eslint-disable-next-line no-lone-blocks
    case 1: {
      name = getElementDomValue('.release .purchase-form .release-report-row #purchase-name');
      if (!(name && name.length > 0)) {
        displayTipView(tipElement, '请输入采购产品名称');
        return;
      }
      amount = getElementDomValue('.release .purchase-form .release-report-row #productCount');
      if (!(amount && amount.length > 0)) {
        displayTipView(tipElement, '请输入采购需求数量');
        return;
      } /* else if (!utils.isValidInt(amount)) {
        displayTipView(tipElement, '请输入有效的需求数量');
        return;
      } */
      mobile = getElementDomValue('.release .purchase-form .release-report-row #purchase-mobile');
      if (!(mobile && mobile.length > 0)) {
        displayTipView(tipElement, '请输入联系电话');
        return;
      } else if (!utils.isValidMobile(mobile) && !utils.isValidTelephone(mobile)) {
        displayTipView(tipElement, '请输入有效的联系电话');
        return;
      }
      content = getElementDomValue('.release .purchase-form .release-report-row #introduce');
      fnCallback = function(bResult, msg) {
        if (bResult) {
          displayTipView(tipElement, '添加成功', 'green');
          getElementDomValue('.release .purchase-form .release-report-row #purchase-name', '');
          getElementDomValue('.release .purchase-form .release-report-row #productCount', '');
          getElementDomValue('.release .purchase-form .release-report-row #purchase-mobile', '');
          getElementDomValue('.release .purchase-form .release-report-row #introduce', '');
        } else {
          displayTipView(tipElement, msg || '添加失败了！');
        }
      };
    }
      break;
    // eslint-disable-next-line no-lone-blocks
    case 2: {
      name = getElementDomValue('.release .supply-form .release-report-row #productName');
      if (!(name && name.length > 0)) {
        displayTipView(tipElement, '请输入供应产品名称');
        return;
      }
      productionPlace = getElementDomValue('.release .supply-form .release-report-row #productionPlace');
      if (!(productionPlace && productionPlace.length > 0)) {
        displayTipView(tipElement, '请输入产品产地');
        return;
      }
      amount = getElementDomValue('.release .supply-form .release-report-row #amount');
      if (!(amount && amount.length > 0)) {
        displayTipView(tipElement, '请输入产品数量');
        return;
      } /* else if (!utils.isValidInt(amount)) {
        displayTipView(tipElement, '请输入有效的产品数量');
        return;
      } */
      mobile = getElementDomValue('.release .supply-form .release-report-row #mobile');
      if (!(mobile && mobile.length > 0)) {
        displayTipView(tipElement, '请输入联系电话');
        return;
      } else if (!utils.isValidMobile(mobile) && !utils.isValidTelephone(mobile)) {
        displayTipView(tipElement, '请输入有效的联系电话');
        return;
      }
      content = getElementDomValue('.release .supply-form .release-report-row #introduce');
      if (!(content && content.length > 0)) {
        displayTipView(tipElement, '请输入产品介绍');
        return;
      }
      fnCallback = function(bResult, msg) {
        if (bResult) {
          displayTipView(tipElement, '添加成功', 'green');
          getElementDomValue('.release .supply-form .release-report-row #productName', '');
          getElementDomValue('.release .supply-form .release-report-row #productionPlace', '');
          getElementDomValue('.release .supply-form .release-report-row #amount', '');
          getElementDomValue('.release .supply-form .release-report-row #mobile', '');
          getElementDomValue('.release .supply-form .release-report-row #introduce', '');
        } else {
          displayTipView(tipElement, msg || '添加失败了！');
        }
      };
    }
      break;
  }
  publishRequirement2Server(nType, name, amount, mobile, productionPlace, content, fnCallback);
}
/**
 * 动态向产品内容区添加产品
 * @param
 *      PageData
 */
function convertProcurementData2DOM(procurement) {
  let htmlText = '<div class="supply">';
  htmlText += (
    '<div class="product-name">' +
      '<span class="supply-time">' + procurement.date + '</span>' +
      '<span class="supply-icon"></span>' +
    '</div>'
  );
  htmlText += ('<div class="product-content">');
  htmlText += (
    '<div class="name">产品名称：' + (procurement.title || '') + '</div>' +
    '<div class="amount">需求数量：' + (procurement.amount || '') + '</div>' +
    '<div class="contact">联系方式：' + (procurement.contactMobile || '') + '</div>'
  );
  if (procurement.content && procurement.content.length > 0) {
    htmlText += ('<div class="content">详情：' + procurement.content + '</div>');
  }
  htmlText += '</div>';
  htmlText += (
    '<div class="product-bottom">' +
      '<span style="visibility: hidden"><i class="iconlocation"></i> 广西桂林泰士特</span>' +
      '<span class="mobile" style="visibility:' + (procurement.mobile ? 'visible' : 'hidden') +'"><i class="iconphone"></i>' + procurement.mobile + '</span>' +
    '</div>'
  );
  htmlText += ('</div>');
  return htmlText;
};
function convertProcurementData2H5DOM(procurement) {
  let htmlText = '<div class="content-supply">' +
                    '<div class="title-supply">' +
                    '<div class="supply-type-supply">购</div>' +
                    '<span>' + (procurement.title || '') + '</span>' +
                    '<span>' + (procurement.date || '') + '</span>' +
                  '</div>';

  htmlText += (
    '<div class="content-supply">' +
      '<div class="amount">需求数量：' + (procurement.amount || '') + '</div>' +
      '<div class="contact">联系方式：' + (procurement.contactMobile || '') + '</div>'
  );
  if (procurement.content && procurement.content.length > 0) {
    htmlText += ('<div class="content">详情：' + procurement.content + '</div>');
  }
  htmlText += '</div>';

  if (procurement.mobile && procurement.mobile.length > 0) {
    htmlText += ('<div class="product-bottom">');
    htmlText += ('<span class="mobile"><img src="/static/image/mobile/call.png" />');
    htmlText += procurement.mobile;
    htmlText += ('</span>');
    htmlText += ('</div>');
  }
  return htmlText;
}
function appendProcurementsToDOM(pageData) {
  var divProductContent = $('.procurement-warpper .supply-content');
  if (divProductContent.length > 0) {
    divProductContent.html('');
    pageData.datas.forEach(procurement => {
      divProductContent.append(convertProcurementData2DOM(procurement));
    });
    var pageElement = $('.procurement-warpper .pagination');
    pagination.appendPageToDOM(pageData, pageElement, bindPageItemClickEvent);
  } else {
    divProductContent = $('.supply-warpper-mobile .supply-list');
    divProductContent.html('');
    pageData.datas.forEach(procurement => {   
      divProductContent.append(convertProcurementData2H5DOM(procurement));
    });
  }
}
/**
 * 动态向产品内容区添加产品
 * @param
 *      PageData
 */
function convertSupplyData2DOM(procurement) {
  let htmlText = '<div class="supply">' +
    '<div class="product-name">' +
      '<span class="supply-time">' + procurement.date + '</span>' +
      '<span class="supply-icon"></span>' +
    '</div>';
  htmlText += ('<div class="product-content">');
  htmlText += (
    '<div class="name">产品名称：' + (procurement.title || '') + '</div>' +
    '<div class="production-place">产品产地：' + (procurement.productionPlace || '') + '</div>' +
    '<div class="amount">产品数量：' + (procurement.amount || '') + '</div>' +
    '<div class="contact">联系方式：' + (procurement.contactMobile || '') + '</div>'
  );
  if (procurement.content && procurement.content.length > 0) {
    htmlText += ('<div class="content">产品介绍：' + procurement.content + '</div>');
  }
  htmlText += '</div>';
  htmlText += (
    '<div class="product-bottom">' +
      '<span style="visibility: hidden"><i class="iconlocation"></i> 广西桂林泰士特</span>' +
      '<span class="mobile" style="visibility:' + (procurement.mobile ? 'visible' : 'hidden') +'"><i class="iconphone"></i>' + procurement.mobile + '</span>' +
    '</div>'
  );
  htmlText += '</div>';
  return htmlText;
};
function convertSupplyData2H5DOM(procurement) {
  let htmlText = '<div class="content-supply">' +
                      '<div class="title-supply">' +
                      '<div class="supply-type-procurement">供</div>' +
                      '<span>' + procurement.title + '</span>' +
                      '<span>' + procurement.date + '</span>' +
                  '</div>';                
  htmlText += (
    '<div class="content-supply">' + 
      '<div class="production-place">产品产地：' + (procurement.productionPlace || '') + '</div>' +
      '<div class="amount">产品数量：' + (procurement.amount || '') + '</div>' +
      '<div class="contact">联系方式：' + (procurement.contactMobile || '') + '</div>'
  );
  if (procurement.content && procurement.content.length > 0) {
    htmlText += ('<div class="content">产品介绍：' + (procurement.content || '') + '</div>');
  }
  htmlText += ('</div>');
  if (procurement.mobile && procurement.mobile.length > 0) {
    htmlText += ('<div class="product-bottom">');
    htmlText += ('<span class="mobile"><img src="/static/image/mobile/call.png" />');
    htmlText += procurement.mobile;
    htmlText += ('</span>');
    htmlText += ('</div>');
  }
  return htmlText;
};
function appendSuppliersToDOM(pageData) {
  var divProductContent = $('.supplier-warpper .supply-content');
  if (divProductContent.length > 0) {
    divProductContent.html('');
    pageData.datas.forEach(supplement => {
      divProductContent.append(convertSupplyData2DOM(supplement));
    });
    var pageElement = $('.supplier-warpper .pagination');
    pagination.appendPageToDOM(pageData, pageElement, bindPageItemClickEvent);
  } else {
    divProductContent = $('.supply-warpper-mobile .supply-list');
    divProductContent.html('');
    pageData.datas.forEach(procurement => {    
      divProductContent.append(convertSupplyData2H5DOM(procurement));
    });
  }
}

/**
 * 从服务器拉取 采购需求列表
 * @param {数据页} nIndex
 * @param {数据请求完成后回调} fn
 */
function onClickedProcurementPageItem(nIndex, fn) {
  $.ajax({
    type: 'GET',
    url: '/supply/getProcurements',
    data: {'pageIndex': nIndex},
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        appendProcurementsToDOM(response.data);
        fn && fn();
      } else {
      }
    }
  });
}
/**
 * 从服务器拉取 供应需求列表
 * @param {数据页} nIndex
 * @param {数据请求完成后回调} fn
 */
function onClickedSupplierPageItem(nIndex, fn) {
  $.ajax({
    type: 'GET',
    url: '/supply/getSuppliers',
    data: {'pageIndex': nIndex},
    success: function(response) {
      if (response && (response.errno === 0) && response.data && response.data.datas) {
        appendSuppliersToDOM(response.data);
        if (fn) {
          fn();
        }
      } else {
      }
    }
  });
}

// 分页器事件绑定
function bindPageItemClickEvent() {
  $('.procurement .procurement-warpper .pagination ul li').each(function(index) {
    const id = $(this).attr('id');
    $(this).click(function() {
      pagination.onClickedPageItem('.procurement .procurement-warpper .pagination', id, onClickedProcurementPageItem);
    });
  });
  $('.supplier .supplier-warpper .pagination ul li').each(function(index) {
    const id = $(this).attr('id');
    $(this).click(function() {
      pagination.onClickedPageItem('.supplier .supplier-warpper .pagination', id, onClickedSupplierPageItem);
    });
  });
}

// 手机端  采购/供应 切换
function onClickedTypeToogle(index) {
  const procurementInputElement = $('.supply-warpper-mobile .procurement-input-panel');
  const supplierInputElement = $('.supply-warpper-mobile .supplier-input-panel');
  if (index === 0) {
    procurementInputElement.css('display', 'block');
    supplierInputElement.css('display', 'none');
    onClickedProcurementPageItem(1);
  } else {
    procurementInputElement.css('display', 'none');
    supplierInputElement.css('display', 'block');
    onClickedSupplierPageItem(1);
  }
}
/**
 * 手机端点击 闪电发布
 * @param
 */
function onClickedMobilePublishRequirement() {
  const displayTipView = require('./common').showToast;

  const name = $('.supply-warpper-mobile .procurement-input-panel #procurement-name').val();
  if (!(name && name.length > 0)) {
    displayTipView('请输入采购产品名称');
    return;
  }
  const amount = $('.supply-warpper-mobile .procurement-input-panel #procurement-amount').val();
  if (!(amount && amount.length > 0)) {
    displayTipView('请输入采购产品数量');
    return;
  }
  const mobile = $('.supply-warpper-mobile .procurement-input-panel #procurement-contact').val();
  if (!(mobile && mobile.length > 0)) {
    displayTipView('请输入联系电话');
    return;
  } else if (!utils.isValidMobile(mobile) && !utils.isValidTelephone(mobile)) {
    displayTipView('请输入有效的联系电话');
    return;
  }
  const description = $('.supply-warpper-mobile .procurement-input-panel #procurement-description').val();
  publishRequirement2Server(1, name, amount, mobile, null, description, function(bResult) {
    if (bResult) {
      $('.supply-warpper-mobile .procurement-input-panel #procurement-description').val('');
      $('.supply-warpper-mobile .procurement-input-panel #procurement-contact').val('');
      $('.supply-warpper-mobile .procurement-input-panel #procurement-amount').val('');
      $('.supply-warpper-mobile .procurement-input-panel #procurement-name').val('');
      displayTipView('添加成功!');
    } else {
      displayTipView('添加失败了！');
    }
  });
}
function onClickedMobilePublishSupply() {
  const displayTipView = require('./common').showToast;

  const name = $('.supply-warpper-mobile .supplier-input-panel #supply-name').val();
  if (!(name && name.length > 0)) {
    displayTipView('请输入供应产品名称');
    return;
  }
  const productionPlace = $('.supply-warpper-mobile .supplier-input-panel #supply-productionPlace').val();
  if (!(productionPlace && productionPlace.length > 0)) {
    displayTipView('请输入产品产地');
    return;
  }
  const amount = $('.supply-warpper-mobile .supplier-input-panel #supply-amount').val();
  if (!(amount && amount.length > 0)) {
    displayTipView('请输入产品数量');
    return;
  }
  const mobile = $('.supply-warpper-mobile .supplier-input-panel #supply-contact').val();
  if (!(mobile && mobile.length > 0)) {
    displayTipView('请输入联系电话');
    return;
  } else if (!utils.isValidMobile(mobile) && !utils.isValidTelephone(mobile)) {
    displayTipView('请输入有效的联系电话');
    return;
  }
  const description = $('.supply-warpper-mobile .supplier-input-panel #supply-description').val();
  if (!(description && description.length > 0)) {
    displayTipView('请输入产品介绍');
    return;
  }
  publishRequirement2Server(2, name, amount, mobile, productionPlace, description, function(bResult) {
    if (bResult) {
      $('.supply-warpper-mobile .supplier-input-panel #supply-description').val('');
      $('.supply-warpper-mobile .supplier-input-panel #supply-contact').val('');
      $('.supply-warpper-mobile .supplier-input-panel #supply-amount').val('');
      $('.supply-warpper-mobile .supplier-input-panel #supply-productionPlace').val('');
      $('.supply-warpper-mobile .supplier-input-panel #supply-name').val('');
      displayTipView('添加成功!');
    } else {
      displayTipView('添加失败了！');
    }
  });
}

function extractNumber(path, length) {
  const val = $(path).val().replace(/[^0-9]/g, '');
  $(path).val(val.slice(0, length));
}

// 点击导航
function supplyNavInit() {
  $('.release-title a').each(function(index) {
    $(this).click(function() {
      $('.release-title a').eq(index).addClass('checked').siblings().removeClass('checked');
      if (index === 0) {
        $('.release .purchase-form').removeClass('no-show');
        $('.release .supply-form').addClass('no-show');
      } else {
        $('.release .supply-form').removeClass('no-show');
        $('.release .purchase-form').addClass('no-show');
      }
    });
  });
  $('.release .release-btn').on('click', onClickedPublishRequirement);
  // $('.release .purchase-form .release-report-row #productCount').on('keyup', function() {
  //   extractNumber('.release .purchase-form .release-report-row #productCount', 10);
  // });
  $('.release .purchase-form .release-report-row #purchase-mobile').on('keyup', function() {
    extractNumber('.release .purchase-form .release-report-row #purchase-mobile', 12);
  });
  // $('.release .supply-form .release-report-row #amount').on('keyup', function() {
  //   extractNumber('.release .supply-form .release-report-row #amount', 10);
  // });
  $('.release .supply-form .release-report-row #mobile').on('keyup', function() {
    extractNumber('.release .supply-form .release-report-row #mobile', 12);
  });
  // 手机端 闪电发布按钮点击
  $('div.supply-warpper-mobile .procurement-input-panel .supply-btn').on('click', onClickedMobilePublishRequirement);
  $('div.supply-warpper-mobile .supplier-input-panel .supply-btn').on('click', onClickedMobilePublishSupply);
  // $('.supply-warpper-mobile .procurement-input-panel #procurement-amount').on('keyup', function() {
  //   extractNumber('.supply-warpper-mobile .procurement-input-panel #procurement-amount', 10);
  // });
  $('.supply-warpper-mobile .procurement-input-panel #procurement-contact').on('keyup', function() {
    extractNumber('.supply-warpper-mobile .procurement-input-panel #procurement-contact', 12);
  });
  // $('.supply-warpper-mobile .supplier-input-panel #supply-amount').on('keyup', function() {
  //   extractNumber('.supply-warpper-mobile .supplier-input-panel #supply-amount', 10);
  // });
  $('.supply-warpper-mobile .supplier-input-panel #supply-contact').on('keyup', function() {
    extractNumber('.supply-warpper-mobile .supplier-input-panel #supply-contact', 12);
  });
}

function supplyContentNavInit() {
  $('.release-content-title a').each(function(index) {
    $(this).click(function() {
      $('.release-content-title a').eq(index).addClass('checked-content').siblings().removeClass('checked-content');
      if (index === 0) {
        $('.procurement').removeClass('content-show');
        $('.supplier').addClass('content-show');
        onClickedProcurementPageItem(1);
      } else {
        $('.supplier').removeClass('content-show');
        $('.procurement').addClass('content-show');
        onClickedSupplierPageItem(1);
      }
    });
  });
  // 分页器事件绑定
  bindPageItemClickEvent();
}

const init = () => {
  supplyNavInit();
  supplyContentNavInit();

  // 手机端点击事件绑定
  $('.supply-warpper-mobile .release-title a').each(function(index) {
    $(this).click(function() {
      onClickedTypeToogle(index);
    });
  });
};
module.exports = { init };
